import { FiltersProvider } from '@Sage/ssm-web5';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { EntityDetailActions } from 'actions';

import { RouteOnMount } from 'utils/routes';
import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import DetailLayout from 'containers/components/layouts/ContentDetailLayout';
import FiltersLayout from 'containers/components/layouts/FiltersLayout';
import Menu from './Menu';
import Content from './Content';
import ContentNavigator from './ContentNavigator';
import CONFIG from './contents/TableConfig';

import './styles.scss';
import DomainVerificationBanner from './components/DomainVerificationBanner';
import MarketingCampaignsDetail from './MarketingCampaignsDetail';

const MarketingCampaigns = ({ onManageSubscribers }) => {
    const dispatch = useDispatch();
    const openDetail = bindActionCreators(EntityDetailActions, dispatch).open;
    const currentDetailId = useRef();
    const config = CONFIG();

    return (
        <FiltersProvider>
            <DetailLayout
                header={<Menu config={config} />}
                navigator={<ContentNavigator />}
                postHeader={<DomainVerificationBanner />}
            >
                <FiltersLayout config={config}>
                    <Content />
                </FiltersLayout>
            </DetailLayout>
            <MarketingCampaignsDetail />
            <Routes>
                <Route
                    index
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns"
                            onMount={() => {
                                currentDetailId.current = null;
                            }}
                        />
                    }
                />
                <Route
                    path=":id/:tab?"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns_details"
                            onMount={(params) => {
                                if (!params.id) return;
                                if (currentDetailId.current === params.id) {
                                    return;
                                }
                                currentDetailId.current = params.id;
                                openDetail(CAMPAIGNS_MARKETING, Number(params.id), false, {
                                    tab: params.tab,
                                });
                            }}
                        />
                    }
                />
            </Routes>
        </FiltersProvider>
    );
};

export default MarketingCampaigns;
